import { render, staticRenderFns } from "./DashboardSideNav.vue?vue&type=template&id=28fe6e55&scoped=true"
import script from "./DashboardSideNav.vue?vue&type=script&lang=js"
export * from "./DashboardSideNav.vue?vue&type=script&lang=js"
import style0 from "./DashboardSideNav.vue?vue&type=style&index=0&id=28fe6e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe6e55",
  null
  
)

export default component.exports